module.exports = __webpack_public_path__ + "static/media/沃联推广mp_icon.00453b15.png";